import { Component, OnInit, ElementRef } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-vendor-due-report',
  templateUrl: './vendor-due-report.component.html',
  styleUrls: ['./vendor-due-report.component.css']
})
export class VendorDueReportComponent implements OnInit {

  constructor(public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  currentPage = 1;
  pageSize = 0;
  recordCount = 0;
  totalPages = 0;
  numberOfPages  () {
      this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage  () {
      this.currentPage = this.currentPage + 1;

  }

  pageSizes  () {
      this.currentPage = 1;
      this.recordCount = 0;
      this.totalPages = 0;
  }

  InventoryModel = {
    PaymentAmount:0,
    TotalDueInvoiceAmount:0,
    Print:"",
     InvoiceNumber:'',
      VendorID: 0,        
      FromDate: '',
      ToDate: '',        
      CurrentIndex: 0,
      PageSize: 20,
  }
  ClearSearch  () {
      this.InventoryModel = {
        PaymentAmount:0,
        TotalDueInvoiceAmount:0,
        Print:"",
          InvoiceNumber: '',
          VendorID: 0,
          FromDate: '',
          ToDate: '',
          CurrentIndex: 0,
          PageSize: 20,
      }
      this.TotalInvoiceAmount = 0;
      this.TotalPaidAmount = 0;
      this.TotalDueAmount = 0;
      this.InvoiceList = [];
  }
  TotalInvoiceAmount = 0;
  TotalPaidAmount = 0;
  TotalDueAmount = 0;
  GetInvoiceDueList  () {
   
      this.InventoryModel.Print = '';
      this.InventoryModel.CurrentIndex = this.currentPage;
      this.InventoryModel.PageSize = this.pageSize;    
      this.InventoryModel.FromDate=this.InventoryModel.FromDate!="" &&  this.InventoryModel.FromDate!=null?moment(this.InventoryModel.FromDate).format('DD-MMM-YYYY'):""
      this.InventoryModel.ToDate=this.InventoryModel.ToDate!="" &&  this.InventoryModel.ToDate!=null?moment(this.InventoryModel.ToDate).format('DD-MMM-YYYY'):""
    
      this.stockService.GetInvoiceDueList(JSON.stringify(this.InventoryModel)).subscribe( (response)=> {
          this.InvoiceList = response.InvoiceList;
        
          this.recordCount = 0;
          if (this.InvoiceList != null && this.InvoiceList.length > 0) {
              this.recordCount = this.InvoiceList[0].RecordCount;
          }
                    this.globalHelper.CheckActionStatus(response);
          this.GetTotalInvoiceAmount();
         
      })
  };
  InvoiceList:any;
  GetTotalInvoiceAmount  () {
      var TotalInvoiceAmount = 0;
      var TotalPaidAmount = 0;
      for (var i = 0; i < this.InvoiceList.length; i++) {
          TotalInvoiceAmount = TotalInvoiceAmount + parseFloat(this.InvoiceList[i].InvoiceAmount)
          TotalPaidAmount = TotalPaidAmount + parseFloat(this.InvoiceList[i].PaidAmount)
      }
      this.TotalInvoiceAmount = TotalInvoiceAmount;
      this.TotalPaidAmount = TotalPaidAmount;
      this.TotalDueAmount =TotalInvoiceAmount-TotalPaidAmount;
  }
  BalanceAmount=0;
  GetBalanceAmount  () {
      this.BalanceAmount = this.InventoryModel.TotalDueInvoiceAmount - this.InventoryModel.PaymentAmount;

  }    
  VendorList:any;
  GetAllVendor  () {
      this.lookupService.GetLookupsList('Vendor', '').subscribe( (data)=> {
          this.VendorList = data.LookupItems;
      });
  }
  FilePath:any;
  GetInvoiceDueDounload  () {
      this.InventoryModel.CurrentIndex = 0;
      this.InventoryModel.PageSize = this.pageSize;
      this.InventoryModel.Print = 'XLS';
      this.InventoryModel.FromDate=this.InventoryModel.FromDate!="" &&  this.InventoryModel.FromDate!=null?moment(this.InventoryModel.FromDate).format('DD-MMM-YYYY'):""
      this.InventoryModel.ToDate=this.InventoryModel.ToDate!="" &&  this.InventoryModel.ToDate!=null?moment(this.InventoryModel.ToDate).format('DD-MMM-YYYY'):""
    
      this.stockService.GetInvoiceDueList(JSON.stringify(this.InventoryModel)).subscribe( (response)=> {
         
          this.FilePath = response.FilePath;
          window.location = response.FilePath;
        
          this.globalHelper.CheckActionStatus(response);
         
      })
  };
 

  ngOnInit() {
    this.GetAllVendor();
  }

}
